import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../index';
import KioskSettingsListPage from '@/features/kiosk/pages/KioskSettingsListPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/settings',
  component: KioskSettingsListPage,
});
